export const bot = {
  modal: {
    // The inbox is no longer WhatsApp-only: it merges WhatsApp, web concierge and OTA.
    title: "Skrzynka wiadomości",
    subtitle: "WhatsApp, konsjerż na stronie i OTA w jednym miejscu",
  },

  channels: {
    all: "Wszystkie",
    whatsapp: "WhatsApp",
    web: "Strona",
    ota: "OTA",
  },

  empty: {
    title: "Brak nowych wiadomości",
    description: "Nowe wiadomości bota pojawią się tutaj, gdy nadejdą",
  },

  buttons: {
    markAll: "Oznacz wszystkie jako przeczytane",
    goToChat: "Skonfiguruj agenta AI",
    archive: "Archiwizuj rozmowę",
  },

  actions: {
    replyWhatsApp: "Odpowiedz na WhatsApp",
  },

  time: {
    now: "Teraz",
    minuteSuffix: "min",
    hourSuffix: "godz.",
    daySuffix: "dn.",
    today: "Dzisiaj",
    yesterday: "Wczoraj",
  },

  questions: {
    searchPlaceholder: "Szukaj pytań...",
    answered: "Z odpowiedzią",
    noAnswer: "Oczekujące",
    withImage: "Ze zdjęciem",
    empty: "Nie znaleziono pytań",
    confirmDelete: "Czy na pewno usunąć to pytanie?",
  },

  answer: {
    assistantResponse: "Odpowiedź asystenta",
    attachedImageOptional: "Załączone zdjęcie (opcjonalnie)",
    uploadImage: "Wgraj zdjęcie",
    clickToSelect: "Kliknij, aby wybrać zdjęcie",
    changeImage: "Zmień zdjęcie",
    imagePreviewAlt: "Podgląd zdjęcia",
    defaultImageName: "zdjecie.jpg",
  },

  phone: {
    online: "online",
    today: "Dzisiaj",
    exampleQuestion: "Przykładowe pytanie",
    writeAnswerPlaceholder: "Napisz odpowiedź na to pytanie...",
    writeMessagePlaceholder: "Napisz wiadomość...",
    answerImageAlt: "Zdjęcie w odpowiedzi",
    confirmDeleteImage: "Usunąć zdjęcie?",
    imageDeletedSuccess: "Zdjęcie zostało usunięte.",
    virtualAssistant: "Wirtualny asystent",
  },

  search: {
    placeholder: "Szukaj po imieniu, telefonie lub kodzie rezerwacji...",
    noResultsTitle: "Nie znaleziono rozmów",
    noResultsDescription:
      "Spróbuj wpisać inne imię, numer telefonu lub kod rezerwacji.",
  },

  archive: {
    title: "Archiwizuj rozmowę",
    message:
      "Po zarchiwizowaniu rozmowa zniknie z tej listy. Nadal będzie dostępna z poziomu powiązanej rezerwacji.",
    cancel: "Anuluj",
    confirm: "Archiwizuj",
  },
};

export default bot;
